import { jsx } from 'react/jsx-runtime';

const ErrorMessage = ({ message }) => {
    if (!message) {
        return null;
    }
    return jsx("div", Object.assign({ className: "pp-error-message" }, { children: message }));
};

export { ErrorMessage };
